module.exports = __webpack_public_path__ + "img/20.5e6c7113.png";